import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

import { fmtCentsAccounting } from "../format";

/**
 * Churn & Contraction card — mirrors the static HTML report. CS-side
 * numbers come from the renewals feature (J-P owns the forecast there);
 * "Upside" is N/A for churn by design (no upside on losing customers).
 *
 * Phase 2 only shows the four CSM-tracked sub-segments collapsed into one
 * row each — the renewals payload doesn't yet split direct vs reseller
 * cancellation/contraction. When it does, swap the row list to the
 * spreadsheet's full four-row layout.
 */
export function ChurnContractionTable({
  title,
  priorLabel,
  closedCents,
  forecastCents,
  priorClosedCents,
  priorForecastCents,
}: {
  title: string;
  priorLabel: string;
  closedCents: number;
  forecastCents: number;
  priorClosedCents?: number | null;
  priorForecastCents?: number | null;
}) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-xs uppercase tracking-wider text-muted-foreground">
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Segment</TableHead>
              <TableHead className="text-right">Closed</TableHead>
              <TableHead className="text-right text-power/70">{priorLabel}</TableHead>
              <TableHead className="text-right">Forecast</TableHead>
              <TableHead className="text-right text-power/70">{priorLabel}</TableHead>
              <TableHead className="text-right text-muted-foreground">Upside</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow>
              <TableCell className="font-medium">Direct cancellation</TableCell>
              <TableCell className="text-right font-mono text-muted-foreground">—</TableCell>
              <TableCell className="text-right font-mono text-muted-foreground">—</TableCell>
              <TableCell className="text-right font-mono text-danger">
                {fmtCentsAccounting(-forecastCents)}
              </TableCell>
              <TableCell className="text-right font-mono text-muted-foreground">
                {priorForecastCents != null ? fmtCentsAccounting(-priorForecastCents) : "—"}
              </TableCell>
              <TableCell className="text-right text-muted-foreground italic">N/A</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="font-medium">Reseller cancellation</TableCell>
              <TableCell colSpan={5} className="text-center text-xs text-muted-foreground italic">
                Awaiting renewals feature split (Phase 2.1)
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="font-medium">Direct contraction</TableCell>
              <TableCell colSpan={5} className="text-center text-xs text-muted-foreground italic">
                Awaiting renewals feature split
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="font-medium">Reseller contraction</TableCell>
              <TableCell colSpan={5} className="text-center text-xs text-muted-foreground italic">
                Awaiting renewals feature split
              </TableCell>
            </TableRow>
            <TableRow className="bg-muted/40 font-medium">
              <TableCell>Subtotal</TableCell>
              <TableCell className="text-right font-mono text-danger">
                {fmtCentsAccounting(-closedCents)}
              </TableCell>
              <TableCell className="text-right font-mono text-muted-foreground">
                {priorClosedCents != null ? fmtCentsAccounting(-priorClosedCents) : "—"}
              </TableCell>
              <TableCell className="text-right font-mono text-danger">
                {fmtCentsAccounting(-forecastCents)}
              </TableCell>
              <TableCell className="text-right font-mono text-muted-foreground">
                {priorForecastCents != null ? fmtCentsAccounting(-priorForecastCents) : "—"}
              </TableCell>
              <TableCell className="text-right text-muted-foreground italic">—</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
